import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FilterModelDto } from '../../models/filter.model';
import { FilterSettingService } from '../../services/filter-setting.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-filter-select',
  templateUrl: './filter-select.component.html',
  styleUrls: ['./filter-select.component.scss'],
})
export class FilterSelectComponent implements OnInit, OnDestroy {
  @Input() isAdditional = false;

  @Input() filter: FilterModelDto[] | undefined;
  @Input() filterTitle: string | undefined;

  @Output() selectFilter: EventEmitter<FilterModelDto> =
    new EventEmitter<FilterModelDto>();

  @Output() setAdditionalType: EventEmitter<FilterModelDto> =
    new EventEmitter<FilterModelDto>();

  isOpenSelectList = false;
  selectedValue: string | undefined;

  subs: Subscription[] = [];

  @HostListener('document:click', ['$event'])
  clickOut(event: MouseEvent) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isOpenSelectList = false;
    }
  }

  constructor(
    private eRef: ElementRef,
    private filterSettingService: FilterSettingService
  ) {}

  ngOnInit() {
    this.initFilterSelect();
  }

  ngOnDestroy() {
    this.subs.forEach((item) => item.unsubscribe());
  }

  initFilterSelect() {
    this.subs.push(
      this.filterSettingService.filterItemReset$.subscribe({
        next: (res) => {
          if (this.filter) {
            if (res.fieldName === this.filter[0].fieldName) {
              this.resetSelect();
            }
          }
        },
      })
    );

    this.subs.push(
      this.filterSettingService.filterAdditionalReset$.subscribe({
        next: () => {
          if (this.isAdditional) {
            this.resetSelect();
          }
        },
      })
    );

    this.subs.push(
      this.filterSettingService.filterAllReset$.subscribe({
        next: () => {
          this.resetSelect();
        },
      })
    );

    this.subs.push(
      this.filterSettingService.filterSelected$.subscribe({
        next: () => {
          this.selectedValue = undefined;
        },
      })
    );
  }

  openSelect(event: MouseEvent) {
    this.isOpenSelectList = !this.isOpenSelectList;
  }

  selectItem(value: FilterModelDto) {
    if (!this.isAdditional) {
      this.filterSettingService.filterSet$.next(value);
    }

    if (this.isAdditional) {
      this.setAdditionalType.emit(value);
    }

    this.selectedValue = value.description;
    this.isOpenSelectList = false;
  }

  resetSelect() {
    this.selectedValue = undefined;
  }
}
